var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionExpansions } from "./actionExpansions";
var initial = {
    expansion: undefined,
    expansionId: -1,
    highlightedExpansionId: -1,
};
export var reducerExpansions = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionExpansions.Select:
            return __assign({}, state, { expansion: action.expansion, expansionId: action.expansionId });
        case TypeActionExpansions.Highlight:
            return __assign({}, state, { highlightedExpansionId: action.expansionId });
        case TypeActionExpansions.StopHighlight:
            var highlightedExpansionId = state.highlightedExpansionId === action.expansionId
                ? -1
                : state.highlightedExpansionId;
            return __assign({}, state, { highlightedExpansionId: highlightedExpansionId });
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/reducerExpansions.ts
// module id = 2969
// module chunks = 3